import type { InterestBasis, LoanDirection, PersonalLoan } from '@/api/personalLoans'
import { today } from '@/lib/transactionDateRangeFilter'

export function formatInterest(basis: InterestBasis, rate: number | null): string {
  if (basis === 'NONE' || rate === null) return 'No interest'
  return `${rate}% / ${basis === 'MONTHLY' ? 'month' : 'year'}`
}

export function isOverdue(loan: PersonalLoan): boolean {
  return !loan.closed && loan.outstanding > 0 && loan.dueDate !== null && loan.dueDate < today()
}

/** Everything a loan write can change. */
export const PERSONAL_LOAN_QUERY_KEYS = [
  'personal-loans',
  'accounts',
  'transactions',
  'dashboard',
  'budget',
  'categories',
  'contacts',
  'analytics',
  'calendar',
  'goals',
  'earmarks',
] as const

export function rateError(basis: InterestBasis, rateText: string): string | null {
  if (basis === 'NONE') return null
  const rate = Number(rateText.trim())
  return !rateText.trim() || Number.isNaN(rate) || rate <= 0 || rate > 100
    ? 'Enter a rate above 0 and at most 100'
    : null
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const ACCOUNT_NAME_MAX = 50

/** Mirrors the server's LoanName; the server adds " #2" etc. when the name is already taken. */
export function defaultLoanName(direction: LoanDirection, person: string, isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number)
  if (!person || !y || !m || !d) return ''
  const prefix = direction === 'LENT' ? 'Loan to ' : 'Loan from '
  const tail = ` · ${d} ${MONTHS[m - 1]} ${y}`
  const room = ACCOUNT_NAME_MAX - prefix.length - tail.length
  const shown = person.length <= room ? person : `${person.slice(0, Math.max(room - 1, 0))}…`
  return prefix + shown + tail
}
